import {
  FaUser,
  FaMapMarkerAlt,
  FaGraduationCap,
  FaBriefcase,
  FaFileSignature,
  FaMoneyBillWave,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { FaTasks } from "react-icons/fa";

import { MdHistory } from "react-icons/md"; 
import { FaWallet } from "react-icons/fa";
export const sidebarItems = [
  { icon: FaUser, label: 'Dashboard', path: '/client/dashboard' },
  { icon: FaMapMarkerAlt, label: 'Profile', path: '/client/profile' },
  { icon: FaGraduationCap, label: 'Add Candidate', path: '/client/add-candidate' },
  {
    icon: FaBriefcase,
    label: 'Pending forms',
    subItems: [
      { label: 'Pending Submission', path: '/client/pending-submission' },
      { label: 'Login Expired Candidates', path: '/client/login-expired' },
    ],
  },
  {
  icon: FaFileSignature,
  label: "Case Submission",
  subItems: [
    { label: "Pending Case Submission", path: "/client/case/pending" },
    { label: "Ready for BGC", path: "/client/case/ready" },
    { label: "Submitted Verification", path: "/client/case/submitted" },
    {
      label: "BGV In Progress Candidates",
      path: "/client/case/in-progress",
    },
    {
      label: "BGV Completed Candidates",
      path: "/client/case/completed",
    },
    { label: "Total Candidates", path: "/client/case/total" },
  ],
},

{
  icon: FaTasks,
  label: "Approve/Deny Requests",
  path: "/client/approve-deny-requests",
},

  {
      icon: FaMoneyBillWave,
      label: 'Payment',
      path: '/client/payment'
    },

{
  icon: FaWallet,
  label: "Client Wallet",
  path: "/client/client-wallet"
},

    {
  icon: MdHistory,
  label: 'Transaction History',
  path: '/client/transaction-history'
},


 

  // {
  //   icon: FaChartBar, 
  //   label: 'Report',
  //   path: '/client/report',
  // },
  // {
  //   icon: FaChartBar, 
  //   label: 'Final Report',
  //   path: '/client/finalreport',
  // },
];
